import styled, { keyframes } from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const FadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

export const SlideIn = keyframes`
  from { transform: translateX(100%); }
  to   { transform: translateX(0); }
`;

export const Backdrop = styled.div<{ $open: boolean }>`
  display: ${({ $open }) => ($open ? "block" : "none")};
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 1000;
  animation: ${FadeIn} 0.2s ease;
`;

export const Pane = styled.div<{ $open: boolean }>`
  display: ${({ $open }) => ($open ? "flex" : "none")};
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 400px;
  max-width: 100vw;
  background: ${ColorV2.White};
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  z-index: 1001;
  animation: ${SlideIn} 0.25s ease;
  overflow: hidden;
`;

export const PaneHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0;
  flex-shrink: 0;
`;

export const PaneTitle = styled.span`
  ${TypographyV2.h5}
  color: ${ColorV2.Blue1};
`;

export const CloseBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${ColorV2.Blue4};
  font-size: 18px;
  line-height: 1;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${ColorV2.Blue1};
    background: ${ColorV2.Blue6};
  }
`;

export const PaneDescription = styled.p`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  margin: 12px 24px 0;
  flex-shrink: 0;
`;

export const PaneFooter = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 24px 24px;
  border-top: 1.5px solid ${ColorV2.Blue6};
  flex-shrink: 0;
  justify-content: flex-end;
`;

/** Shown in PaneFooter when a save fails — margin-right:auto pushes the
 * Cancel/Save buttons to the end regardless of the footer's own justify-content. */
export const SaveErrorText = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.NegativeRed};
  margin-right: auto;
  align-self: center;
`;
